import script from "./RaceCanicross2026.vue?vue&type=script&setup=true&lang=js"
export * from "./RaceCanicross2026.vue?vue&type=script&setup=true&lang=js"

import "./RaceCanicross2026.vue?vue&type=style&index=0&id=756e7ab7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-756e7ab7"]])

export default __exports__